// extracted by mini-css-extract-plugin
export default {"userSelect":"P1kXDPNRXz9RaeUHRRt1__userSelect___","roleList":"mjS99DCQkkhcwB3B3hhJ__roleList___","roleSelect":"iqISlM03rdPdaBR2zCXZ__roleSelect___"};